/**
 * Rhenus RVK API
 * \"Rhenus RVK user and admin API Definitions\"
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { inject, injectable, named } from "inversify";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Headers } from "../Headers";
import { HttpResponse } from "../HttpResponse";
import { IAPIConfiguration } from "../IAPIConfiguration";
import { IHttpClient } from "../IHttpClient";

import { JSONClosedOrders } from "../model/jSONClosedOrders";
import { JSONfileDownload } from "../model/jSONfileDownload";
import { JSONOrderId } from "../model/jSONOrderId";
import { JSONresponseOpenFiles } from "../model/jSONresponseOpenFiles";
import { JSONresponseOpenUserOrders } from "../model/jSONresponseOpenUserOrders";
import { Response } from "../model/response";

import { COLLECTION_FORMATS } from "../variables";
import { RvkWorkServiceInterface } from "./rvkWork.serviceInterface";

@injectable()
export class RvkWorkService implements RvkWorkServiceInterface {
  private basePath: string = "http://kubernetes.slsprototyp.de/service/rvk/api";

  constructor(
    @inject(IHttpClient)
    @named("RvkWorkService")
    private httpClient: IHttpClient,
    @inject(IAPIConfiguration)
    @named("RvkWorkService")
    private APIConfiguration: IAPIConfiguration
  ) {
    if (this.APIConfiguration.basePath) {
      this.basePath = this.APIConfiguration.basePath;
    }
  }

  /**
   * Rhenus intern Employee abort an order
   * @param orderID Order number of the file
   */
  public abortOrderUsingDELETE(
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abortOrderUsingDELETE(
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public abortOrderUsingDELETE(
    orderID: number,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (orderID == null) {
      throw new Error(
        "Required parameter orderID was null or undefined when calling abortOrderUsingDELETE."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";

    const response: Observable<HttpResponse<Response>> = this.httpClient.delete(
      `${this.basePath}/files/abortorder/${encodeURIComponent(
        String(orderID)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }

  /**
   * Customer wants to cancel his upload
   * @param orderID Order number of the file
   */
  public abortUploadUsingDELETE(
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abortUploadUsingDELETE(
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public abortUploadUsingDELETE(
    orderID: number,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (orderID == null) {
      throw new Error(
        "Required parameter orderID was null or undefined when calling abortUploadUsingDELETE."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";

    const response: Observable<HttpResponse<Response>> = this.httpClient.delete(
      `${this.basePath}/files/abortupload/${encodeURIComponent(
        String(orderID)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }

  /**
   * Admin has approved and now we send the order to the customer
   * @param orderID Order number of the files to send to customer
   */
  public approvedAdminFilesUsingPOST(
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public approvedAdminFilesUsingPOST(
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public approvedAdminFilesUsingPOST(
    orderID: number,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (orderID == null) {
      throw new Error(
        "Required parameter orderID was null or undefined when calling approvedAdminFilesUsingPOST."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";

    const response: Observable<HttpResponse<Response>> = this.httpClient.post(
      `${this.basePath}/files/approvedadminfiles/${encodeURIComponent(
        String(orderID)
      )}`,
      undefined,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }

  /**
   * User/Customer has approved and now we send the order to the Rhenus User
   * @param orderID Order number of the files to send to Rhenus
   */
  public approvedUserFilesUsingPOST(
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public approvedUserFilesUsingPOST(
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public approvedUserFilesUsingPOST(
    orderID: number,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (orderID == null) {
      throw new Error(
        "Required parameter orderID was null or undefined when calling approvedUserFilesUsingPOST."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";

    const response: Observable<HttpResponse<Response>> = this.httpClient.post(
      `${this.basePath}/files/approveduserfiles/${encodeURIComponent(
        String(orderID)
      )}`,
      undefined,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }

  /**
   * Get all my closed orders as customer
   * @param customername GetCustomer Closed Order by given customername
   */
  public closedOrdersByGivenCustomerNameUsingGET(
    customername: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONClosedOrders[]>;
  public closedOrdersByGivenCustomerNameUsingGET(
    customername: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONClosedOrders[]>>;
  public closedOrdersByGivenCustomerNameUsingGET(
    customername: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (customername == null) {
      throw new Error(
        "Required parameter customername was null or undefined when calling closedOrdersByGivenCustomerNameUsingGET."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*, application/json";

    const response: Observable<
      HttpResponse<JSONClosedOrders[]>
    > = this.httpClient.get(
      `${
        this.basePath
      }/files/closedOrdersByGivenCustomerName/${encodeURIComponent(
        String(customername)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONClosedOrders[]
        )
      );
    }
    return response;
  }

  /**
   * Give a file based on the orderID and fileName
   * @param fileDownload fileDownload
   */
  public downloadUserFileBodyUsingPOST(
    fileDownload: JSONfileDownload,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public downloadUserFileBodyUsingPOST(
    fileDownload: JSONfileDownload,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public downloadUserFileBodyUsingPOST(
    fileDownload: JSONfileDownload,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (fileDownload == null) {
      throw new Error(
        "Required parameter fileDownload was null or undefined when calling downloadUserFileBodyUsingPOST."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/octet-stream";
    headers["Content-Type"] = "application/json";

    const response: Observable<HttpResponse<any>> = this.httpClient.post(
      `${this.basePath}/files/downloadfilebody`,
      fileDownload,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * Give a file based on the orderID and fileName
   * @param fileName Name of the file
   * @param orderID Order number of the file
   */
  public downloadUserFileUsingGET(
    fileName: string,
    orderID: number,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public downloadUserFileUsingGET(
    fileName: string,
    orderID: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public downloadUserFileUsingGET(
    fileName: string,
    orderID: number,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (fileName == null) {
      throw new Error(
        "Required parameter fileName was null or undefined when calling downloadUserFileUsingGET."
      );
    }

    if (orderID == null) {
      throw new Error(
        "Required parameter orderID was null or undefined when calling downloadUserFileUsingGET."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*, application/json";

    const response: Observable<HttpResponse<any>> = this.httpClient.get(
      `${this.basePath}/files/userfile/${encodeURIComponent(
        String(orderID)
      )}/${encodeURIComponent(String(fileName))}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * Save the vorschlag and auftrags file from the Rhenus intern employee.
   * @param agreementfile Stream of the agreement file
   * @param auftragsfile Stream of the auftrags file
   * @param customername For this customers are the files
   * @param daystodeleteorder Days until delete the files and the order
   * @param vorschlagliste Stream of the vorschlag file
   */
  public filesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    customername?: string,
    daystodeleteorder?: number,
    vorschlagliste?: Blob,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONOrderId>;
  public filesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    customername?: string,
    daystodeleteorder?: number,
    vorschlagliste?: Blob,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONOrderId>>;
  public filesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    customername?: string,
    daystodeleteorder?: number,
    vorschlagliste?: Blob,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const formData: FormData = new FormData();
    if (agreementfile !== undefined) {
      formData.append("agreementfile", agreementfile as any);
    }
    if (auftragsfile !== undefined) {
      formData.append("auftragsfile", auftragsfile as any);
    }
    if (customername !== undefined) {
      formData.append("customername", customername as any);
    }
    if (daystodeleteorder !== undefined) {
      formData.append("daystodeleteorder", daystodeleteorder as any);
    }
    if (vorschlagliste !== undefined) {
      formData.append("vorschlagliste", vorschlagliste as any);
    }

    const response: Observable<
      HttpResponse<JSONOrderId>
    > = this.httpClient.post(
      `${this.basePath}/files/adminfiles`,
      formData,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as JSONOrderId)
      );
    }
    return response;
  }

  /**
   * Get all my closed orders as customer
   */
  public getClosedOrdersCustomerUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONClosedOrders[]>;
  public getClosedOrdersCustomerUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONClosedOrders[]>>;
  public getClosedOrdersCustomerUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*, application/json";

    const response: Observable<
      HttpResponse<JSONClosedOrders[]>
    > = this.httpClient.get(
      `${this.basePath}/files/closedOrdersCustomer`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONClosedOrders[]
        )
      );
    }
    return response;
  }

  /**
   * Get all open orders for the customer (first step after upload from the Rhenus)
   */
  public getOpenFilesForUserUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONresponseOpenFiles[]>;
  public getOpenFilesForUserUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONresponseOpenFiles[]>>;
  public getOpenFilesForUserUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*, application/json";

    const response: Observable<
      HttpResponse<JSONresponseOpenFiles[]>
    > = this.httpClient.get(`${this.basePath}/files/newuserfiles`, headers);
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONresponseOpenFiles[]
        )
      );
    }
    return response;
  }

  /**
   * Get all open orders for the customer (second step after edit the given files)
   */
  public openOrdersForUserUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONresponseOpenFiles[]>;
  public openOrdersForUserUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONresponseOpenFiles[]>>;
  public openOrdersForUserUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*, application/json";

    const response: Observable<
      HttpResponse<JSONresponseOpenFiles[]>
    > = this.httpClient.get(`${this.basePath}/files/openorders`, headers);
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONresponseOpenFiles[]
        )
      );
    }
    return response;
  }

  /**
   * Get all open orders for the Rhenus employee for the overview
   */
  public openRhenusOrdersUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONresponseOpenUserOrders[]>;
  public openRhenusOrdersUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONresponseOpenUserOrders[]>>;
  public openRhenusOrdersUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*, application/json";

    const response: Observable<
      HttpResponse<JSONresponseOpenUserOrders[]>
    > = this.httpClient.get(`${this.basePath}/files/openrhenusorders`, headers);
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONresponseOpenUserOrders[]
        )
      );
    }
    return response;
  }

  /**
   * Get all open orders for the Customer for the overview
   */
  public openUserOrdersUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONresponseOpenUserOrders[]>;
  public openUserOrdersUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONresponseOpenUserOrders[]>>;
  public openUserOrdersUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*, application/json";

    const response: Observable<
      HttpResponse<JSONresponseOpenUserOrders[]>
    > = this.httpClient.get(`${this.basePath}/files/openuserorders`, headers);
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONresponseOpenUserOrders[]
        )
      );
    }
    return response;
  }

  /**
   * Save the vorschlag and auftrags file from the external user
   * @param agreementfile Stream of the agreement file
   * @param auftragsfile Stream of the auftrags file
   * @param orderid This is the orderId to find the order
   * @param vorschlagliste Stream of the vorschlag file
   */
  public userFilesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    orderid?: number,
    vorschlagliste?: Blob,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONOrderId>;
  public userFilesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    orderid?: number,
    vorschlagliste?: Blob,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONOrderId>>;
  public userFilesUsingPOST(
    agreementfile?: Blob,
    auftragsfile?: Blob,
    orderid?: number,
    vorschlagliste?: Blob,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const formData: FormData = new FormData();
    if (agreementfile !== undefined) {
      formData.append("agreementfile", agreementfile as any);
    }
    if (auftragsfile !== undefined) {
      formData.append("auftragsfile", auftragsfile as any);
    }
    if (orderid !== undefined) {
      formData.append("orderid", orderid as any);
    }
    if (vorschlagliste !== undefined) {
      formData.append("vorschlagliste", vorschlagliste as any);
    }

    const response: Observable<
      HttpResponse<JSONOrderId>
    > = this.httpClient.post(
      `${this.basePath}/files/userfiles`,
      formData,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as JSONOrderId)
      );
    }
    return response;
  }
}
